import type { ComponentProps } from "react";

export function Logout(props: ComponentProps<"svg">) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={29}
			height={28}
			fill="none"
			{...props}
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M12.015 21.148a.9.9 0 0 0 0-1.8h-1.05a2.1 2.1 0 0 1-2.1-2.1v-6.542c0-1.16.94-2.1 2.1-2.1h1.05a.9.9 0 0 0 0-1.8h-1.05a3.9 3.9 0 0 0-3.9 3.9v6.542a3.9 3.9 0 0 0 3.9 3.9h1.05Zm4.483-10.132 1.595 1.414a.4.4 0 0 1-.266.7h-5.823c-.511 0-.928.39-.93.872-.001.482.412.873.924.873h6.112a.4.4 0 0 1 .283.683l-1.708 1.708a.837.837 0 0 0 .037 1.234.968.968 0 0 0 1.31-.04l3.86-3.86a.837.837 0 0 0-.037-1.234L17.77 9.743a.968.968 0 0 0-1.31.04.837.837 0 0 0 .038 1.233Z"
				clipRule="evenodd"
			/>
		</svg>
	);
}
